module.exports = __webpack_public_path__ + "static/media/tiktok.cc00335b.svg";